export default __webpack_public_path__ + "static/media/property_576.a45be277.png";